import React from 'react'
import type { TechnicalSpecificationState } from '../../../../../../services/projectAutofillDraftService.ts'
import {
  addTechnicalSpecSection,
  applyTechnicalSpecSectionBodyChange,
  applyTechnicalSpecSectionTitleChange,
  MAX_TECHNICAL_SPEC_BODY_CHARS,
  MAX_TECHNICAL_SPEC_SECTIONS,
  removeTechnicalSpecSection
} from '../../../../../../utils/conversationalMode/technicalSpecStateUtils.ts'
import styles from './TechnicalSpecEditor.module.scss'

type Props = {
  state: TechnicalSpecificationState
  onChange: (next: TechnicalSpecificationState) => void
  disabled?: boolean
}

const TechnicalSpecEditor: React.FC<Props> = ({ state, onChange, disabled = false }) => {
  return (
    <div className={styles.wrap}>
      {state.sections.map((section) => (
        <div key={section.id} className={styles.section}>
          <div className={styles.sectionHead}>
            <input
              type="text"
              className={styles.titleInput}
              value={section.title}
              disabled={disabled}
              onChange={(e) =>
                onChange(applyTechnicalSpecSectionTitleChange(state, section.id, e.target.value))
              }
            />
            <button
              type="button"
              className={styles.removeBtn}
              disabled={disabled || state.sections.length <= 1}
              onClick={() => onChange(removeTechnicalSpecSection(state, section.id))}
            >
              Quitar sección
            </button>
          </div>
          <textarea
            className={styles.bodyInput}
            value={section.body}
            disabled={disabled}
            maxLength={MAX_TECHNICAL_SPEC_BODY_CHARS}
            placeholder="Describí alcance, materiales, ejecución u otros criterios para este rubro…"
            onChange={(e) =>
              onChange(applyTechnicalSpecSectionBodyChange(state, section.id, e.target.value))
            }
          />
        </div>
      ))}
      <div className={styles.toolbar}>
        <button
          type="button"
          className={styles.addBtn}
          disabled={disabled || state.sections.length >= MAX_TECHNICAL_SPEC_SECTIONS}
          onClick={() => onChange(addTechnicalSpecSection(state))}
        >
          Agregar sección
        </button>
      </div>
    </div>
  )
}

export default TechnicalSpecEditor
